export default "/fonts/vendor/@fortawesome/fontawesome-free/webfa-brands-400.eot?607a77859353c0cc1882b51e1e269d38";